import { LoadingInterface } from '@samc/centricity-core';
import { WindowManager, UUID, WindowClosedEvent, SubWindow, WindowUrl, WindowManagerFactory, SUBWINDOW_PREF_STORE_KEY, IEvent } from '@samc/common';
import { MessageBus } from '@samc/message-bus';
import { ItemSelectedEvent } from './Events/ItemSelectedEvent';
import { LoanSyncEvent } from './Events/LoanSyncEvent';

const DOUBLE_CLICK_TIME = 550;//MS default ms for double click timeout is 500 // should jsut get mbms to add event to grid

export default class LoanDetailsHandler {
  public static domain: 'loan-domain' = 'loan-domain';

  private readonly messageBus: MessageBus;
  private get winMan(): WindowManager { return (window as any).$windowManager; }
  private mostRecentSelection: { itemId: UUID, time: number, newTab: boolean } | null = null;
  private selectTimer: number | NodeJS.Timeout = 0;
  private ctrlDown: boolean = false;
  public isActive: boolean = false;

  private isLoading: boolean = false;
  private isWindowOpen: boolean = false;

  public constructor(private $loading: ReturnType<typeof LoadingInterface>) {
    this.messageBus = new MessageBus();
    this.messageBus.start();

    this.messageBus.onMessage<IEvent>(LoanDetailsHandler.domain, evt => {
      if (evt !== undefined) {
        switch (evt.name) {
          case LoanSyncEvent.eventName:
            {
              const data = evt as LoanSyncEvent;
              this.isWindowOpen = data.isWindowOpen;

              if (this.isLoading) {
                this.$loading();
                this.isLoading = false;
              }
            }
            break;
          case WindowClosedEvent.eventName:
            this.windowClosed(evt as WindowClosedEvent);
            break;
        }
      }
    });

    window.$log("new loan details handler for window:", window.screen, {
      l: window.screenLeft,
      t: window.screenTop,
      x: window.screenX,
      y: window.screenY
    });
  }

  // order of events: singleClickHandler -> onSelect  -> dblClick
  public async onSelection(a: string[]) {
    if (!this.winMan) { return }
    if (a.length === 1) { //ignore selections unless single 
      window.$log('###### LoanDetailsHandler.onSelection Processing received primary keys', a);
      this.mostRecentSelection = { itemId: a[0].toString() as UUID, time: Date.now(), newTab: this.ctrlDown };
      if (this.isWindowOpen) { //a subwindow should already be open before we start responding to selections
        clearTimeout(this.selectTimer);
        this.selectTimer = setTimeout(() => { this.selectItem(); }, DOUBLE_CLICK_TIME); //waiting to see if there was a double click effectively debounces
      }
    }
  }

  // order of events: singleClickHandler -> onSelect  -> dblClick
  public async onDoubleClick(loanId: string) {
    this.mostRecentSelection = { itemId: loanId.toString() as UUID, time: Date.now(), newTab: this.ctrlDown };
    if (!this.winMan) { return }
    this.griddouble();
  }

  public selectItem() {
    if (!this.isActive || !this.winMan || !this.mostRecentSelection) return;

    if (!this.isWindowOpen) {
      window.$log("getting subwindow with location preference: ", window.localStorage.getItem(SUBWINDOW_PREF_STORE_KEY));
      this.winMan.getWindow('loans', this.mostRecentSelection.itemId) as SubWindow;
      this.$loading('Loading Loan Details');
      this.isLoading = true;
      return;
    }
    
    let evt = new ItemSelectedEvent(this.winMan?.currentWindowId as string, '', this.mostRecentSelection.itemId, this.mostRecentSelection.newTab);
    this.messageBus.postMessage(LoanDetailsHandler.domain, evt);

    var subWindow = this.winMan.getWindow('loans', this.mostRecentSelection.itemId) as SubWindow;
    subWindow.window.focus();

    this.mostRecentSelection = null;
  }

  public initialize() {
    if (!this.winMan) {
      (window as any).$windowManager = WindowManagerFactory.getWindowManager({ newWindowUrl: '/SubWindow' as WindowUrl });
    }

    if (!this.winMan) {
      console.error('Failed to initialize LoanDetailsHandler WindowManager');
      return;
    }

    this.isActive = true;
  }
  /*
   * Allows you to temporarily disable processing of grid actions
   */
  public setActive(active: boolean) {
    this.isActive = active;
  }

  private windowClosed(e: WindowClosedEvent) {
    window.$log.info('subwindow closed');
    this.isWindowOpen = false;
    this.$loading();
  }

  private griddouble() {
    if (!this.mostRecentSelection) {
      return;
    }
    clearTimeout(this.selectTimer);
    this.mostRecentSelection.newTab = true;
    this.selectItem();
  }
}